import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface IconWithTextProps{
    icon: IconProp
    color: string
    text: string
}

export const IconWithText = (props: IconWithTextProps) =>{
    return (
        <div style={{ padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <FontAwesomeIcon color={props.color} icon={props.icon} />
            <div style={{ whiteSpace: "nowrap", paddingLeft: "10px"}} >{props.text}</div>
        </div>
    );
}

export const IconWithTextRight = (props: IconWithTextProps) =>{
    return (
        <div style={{ padding: "10px", display: "flex", justifyContent: "right", alignItems: "center" }}>
            <div style={{ whiteSpace: "nowrap", paddingRight: "10px"}} >{props.text}</div>
            <FontAwesomeIcon color={props.color} icon={props.icon} />
        </div>
    );
}